<div class="sub-footer-preauth" *ngIf="getPreAutorisationData() as preauthCard">
  <div class="preauth-content">
    <div class="step-number">3</div>
    <img [src]="preauthCard.urlIcone" alt="" aria-hidden="true" class="icon-footer" />
    <h2 class="sub-footer-preauth-header" *ngIf="preauthCard.titre" class="title-footer">
      {{ preauthCard.titre | translate }}
    </h2>
    <app-content-preautorisation-dashboard
      class="app-habitation-v2"
      [lienBtn]="preauthCard.contentCard[0].lienBtn"
      [content]="preauthCard.contentCard[0]"
      [isDefaultBtnColor]="false"
      id="sectionPreautorisation"
    ></app-content-preautorisation-dashboard>
  </div>
</div>
